<template>
  <!-- Checkbox + `group-has` pair with HorizontalAccordionItem (`group`) and Content. -->
  <input
    :id="accordionInputId"
    type="checkbox"
    class="accordion-open hidden" />
  <label
    :for="accordionInputId"
    class="flex cursor-pointer gap-3 lg:gap-6 rounded-s-md items-stretch
      accordion-item group-has-[.accordion-open:checked]:after:-translate-y-1/2!
      group-has-[.accordion-open:checked]:after:rotate-180!"
    v-bind="$attrs">
    <slot></slot>
  </label>
</template>

<script setup lang="ts">
  import {useId} from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  const accordionInputId = useId();
</script>
